import { render, staticRenderFns } from "./createAndEditNewInformation.vue?vue&type=template&id=6a48694d&scoped=true&"
import script from "./createAndEditNewInformation.vue?vue&type=script&lang=js&"
export * from "./createAndEditNewInformation.vue?vue&type=script&lang=js&"
import style0 from "./createAndEditNewInformation.vue?vue&type=style&index=0&id=6a48694d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48694d",
  null
  
)

export default component.exports